import { Email, Person, Phone, VpnKey } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import SaveIcon from "@mui/icons-material/Save";
import { Box, Button, Grid2, Typography, Input, TextField } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import makeStyles from "@mui/styles/makeStyles";
import React, { useEffect, useState, useRef } from "react";
import PhoneNumberFormattedInput from "../../common/PhoneNumberFormattedInput";
import { useAuth } from "../../hooks/useAuth";
import {
  NotificationType,
  useNotification,
} from "../../hooks/use-notification";
import { useNavigate } from "react-router-dom";
import logo from "../../images/logo.png";
import SingleForm from "../SingleForm";
import PasswordIcon from '@mui/icons-material/Password';
// import PhoneInput from 'react-phone-number-input'
import PhoneInput from 'react-phone-number-input/input'
import CustomPhoneInput from '../../common/CustomPhoneInput'
import { isValidPhoneNumber } from 'react-phone-number-input'
import { PasswordRules, passwordValidator } from "../../common/PasswordRules";
import validator from 'validator'

const Registration = () => {
  const { signUp } = useAuth();
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");

  const { set: setNotification } = useNotification();

  // const emailValidator = value => {
  //   if (!/^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/.test(value))
  //     return false;
  //   return true;
  // };

  const handleSubmit = (event) => {
    event.preventDefault();
   
    if (!passwordValidator(password)) {
      setNotification({
        type: NotificationType.error,
        message: 'Invalid password'
      });
      return;
    }

    if (password !== repeatPassword) {
      setNotification({
        type: NotificationType.error,
        message: 'Password do not match'
      });
      return;
    }

    if (!isValidPhoneNumber(phone)) {
      setNotification({
        type: NotificationType.error,
        message: 'Phone number is not valid'
      });
      return;
    }

    if (!validator.isEmail(email)) {
      setNotification({
        type: NotificationType.error,
        message: 'Email address is not valid'
      });
      return;
    }    

    signUp(email, password, {
      name: `${firstName} ${lastName}`,
      given_name: firstName,
      family_name: lastName,
      phone_number: phone,
    })
      .then((data) => {
        setNotification({
          type: NotificationType.success,
          message: `Success! Please check your email for the confirmation code.`,
        });
        navigate(`/registration/verify?email=${encodeURIComponent(email)}`);
      })
      .catch((err) => {
        console.log(err);
        setNotification({
          type: NotificationType.error,
          message: err.message.includes("password")
            ? "Password must be 8 characters, upper and lower case and numeric and symbol"
            : err.message,
        });
      });
  };

  return (
    <SingleForm
      title="Registration"
      onSubmit={handleSubmit}
    >
      <div>
        <Typography variant="h5">
          Thank you for partnering with New Eyes! Together we help those
          in need see clearly and build better lives.
        </Typography>
        <Typography variant="subtitle1">
          Please provide your email address for registration
        </Typography>
      </div>

      {/* <Grid2 size={12} sm={6}> */}
      <Input
        value={firstName}
        onChange={e => setFirstName(e.target.value)}
        required
        fullWidth
        placeholder="First Name"
        startAdornment={
          <InputAdornment position="start">
            <Person color="primary" />
          </InputAdornment>
        }
      />
      <Input
        value={lastName}
        onChange={e => setLastName(e.target.value)}
        required
        fullWidth
        placeholder="Last Name"
        startAdornment={
          <InputAdornment position="start">
            <Person color="primary" />
          </InputAdornment>
        }
      />
      <PhoneInput
        country="US"
        value={phone}
        onChange={setPhone}
        inputComponent={CustomPhoneInput}
        required
        error={phone && !isValidPhoneNumber(phone) ? 'Invalid phone number' : undefined}
      />

      <Input
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        margin="dense"
        fullWidth
        type="email"
        size="small"
        required
        startAdornment={
          <InputAdornment position="start">
            <Email color="primary" />
          </InputAdornment>
        }
      />
      <Input
        value={password}
        onChange={e => setPassword(e.target.value)}
        placeholder="Enter Password"
        type="password"
        fullWidth
        required
        startAdornment={
          <InputAdornment position="start">
            <PasswordIcon color="primary" />
          </InputAdornment>
        }
      />
      <PasswordRules password={password} />
      <Input
        value={repeatPassword}
        onChange={e => setRepeatPassword(e.target.value)}
        placeholder="Enter Password Again"
        type="password"
        fullWidth
        required
        startAdornment={
          <InputAdornment position="start">
            <PasswordIcon color="primary" />
          </InputAdornment>
        }
      />
      <Grid2
        container
        justifyContent="space-around"
        alignItems="center"
      >
        <Grid2 size={5}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            startIcon={<SaveIcon />}
            type="submit"
          >
            Sign Up
          </Button>
        </Grid2>
        <Grid2 size={2}>&nbsp;</Grid2>
        <Grid2 size={5}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            startIcon={<CancelIcon />}
            onClick={() => navigate("/")}
          >
            Back to Login
          </Button>
        </Grid2>
      </Grid2>
    </SingleForm>
  );
};

export default Registration;
